
import { defineComponent } from 'vue';
import CatalogCardComponent from '../Cards/CatalogCardComp.vue';
import { mapGetters } from 'vuex';
import PaginationComponent from '@/components/Pagination/PaginationComp.vue';
import CatalogCardPreloaderComponent from "@/components/Cards/CatalogCardPreloaderComp.vue";


export default defineComponent({
	name: 'CatalogCardsComponent',
    components: {
      CatalogCardPreloaderComponent,
        CatalogCardComponent,
        PaginationComponent
    },
    computed: {
        ...mapGetters(["getCatalogMods", "getCardsPreloaders", "getPaginationData"])
    }
})
